(function ($) {

    const $catalogItems = $('.catalog-items');
    const $catalogFilterForm = $('#catalog-filter-form');

    const collectFilterParams = function () {
        const params = new URLSearchParams();
        $('input[type="checkbox"]:checked', '#catalog-filter-form').each(function () {
            params.append($(this).attr('name'), $(this).val());
        });
        return params;
    };

    const fetchProducts = function (filterParams) {
        const ajaxParams = new URLSearchParams(filterParams);
        ajaxParams.set('action', $catalogFilterForm.attr('data-action'));
        ajaxParams.set('nonce', $catalogFilterForm.attr('data-nonce'));

        $catalogItems.addClass('is-loading');

        $.ajax({
            url: $catalogFilterForm.attr('data-ajax-url'),
            method: 'POST',
            data: ajaxParams.toString(),
            success: function (response) {
                if (response.success) {
                    $catalogItems.html(response.data.html);
                }
            },
            complete: function () {
                $catalogItems.removeClass('is-loading');
            }
        });
    };

    const updateUrl = function (filterParams) {
        const search = filterParams.toString().replace(/%5B%5D/gi, '[]');
        history.replaceState(null, '', window.location.pathname + (search ? '?' + search : ''));
    };

    $(document).ready(function () {

        // Changement de filtre
        $(document).on('change', '#catalog-filter-form input[type="checkbox"]', function () {
            const filterParams = collectFilterParams();
            // Réinitialise la pagination à la page 1 lors d'un changement de filtre
            filterParams.delete('paged');
            updateUrl(filterParams);
            fetchProducts(filterParams);
        });

        $(document).on('click', '.catalog-items a.page-numbers', function (e) {
            e.preventDefault();

            const href = $(this).attr('href');
            const url = new URL(href, window.location.origin);

            const pagedFromQuery = url.searchParams.get('paged');
            const pagedFromPath = href.match(/\/page\/(\d+)/);
            const paged = pagedFromQuery || (pagedFromPath ? pagedFromPath[1] : null);

            const filterParams = collectFilterParams();
            if (paged && parseInt(paged) > 1) {
                filterParams.set('paged', paged);
            } else {
                filterParams.delete('paged');
            }

            updateUrl(filterParams);
            fetchProducts(filterParams);
            window.scrollTo({top: 0, behavior: 'smooth'});
        });

    });

})(jQuery);
